import React, { useState } from "react";
import { DotsNine } from "phosphor-react";
import { VDS_S3_URL } from "../../constants/ApiUrls";

import "./index.scss";

const SidePanel = (props) => {
  const { show, hidePanel } = props;
  return (
    <div className="sidepanel-container">
      <div className={` sidepanel-main ${show ? "showpanel" : "hidepanel"}`}>
        <DotsNine
          onClick={hidePanel}
          weight="bold"
          size={35}
          className="crossbtn"
          cursor="pointer"
          style={{ zIndex: "100000000 !important" }}
        />
        <nav className="linksparent">
          {JSON.parse(localStorage.getItem("products"))?.map((item) => {
            return (
              <a
                className={`menu-linkk ${
                  item?.translatedValue.toLowerCase() === "futurecare" &&
                  "active"
                }`}
                href={item?.redirectUrl}
                key={item?.productId}
                target="_blank"
              >
                <img
                  src={require("../../assets/images" + item?.imageUrl)}
                  width={30}
                  height={30}
                  style={{ objectFit: "contain" }}
                />

                <span className="heading-smb"> {item?.translatedValue}</span>
              </a>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default SidePanel;
